<template>
    <div class="mbs-left">
        <div class="tit" v-if="isDef">{{ $i18nUtil.trans("message.LoginLeft.001", "효율적인 팀 협업") }}</div>
        <div class="tit" v-if="!isDef">LifePlus Team</div>
        <div class="txt" v-if="isDef" v-html="$i18nUtil.trans('message.LoginLeft.002', '조직과 개인의 목표, 성과를 업무공유시스템에서 달성해보세요.')">
        </div>
        <div class="txt" v-if="!isDef">
            Life Solution Provider for<br> Financial Freedom
        </div>
        <ul class="clear" v-if="isDef">
            <li>OKR</li>
            <li>Collaboration</li>
            <li>Share</li>
        </ul>
        <ul class="clear" v-if="!isDef">
            <li>Professionalism</li>
            <li>Together</li>
            <li>Balance</li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isDef : null
        }
    },
    mounted() {
        this.isDefCheck();
    },
    methods : {
        isDefCheck() {
            let hostInfo = location.host;
            if(hostInfo.indexOf("def")) {
                this.isDef = false;
            } else {
                this.isDef = true;
            }
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/login/base/LoginLeft.vue